import logError from '@/helpers/logError';

export interface UserData {
	referenceID: string | null;
	mtaAnonymousID: string | null;
	firstName: string | null;
	lastName: string | null;
	email: string | null;
}

const Routes = {
	REPAIR: 'repair',
	REPLACE_VIRTUAL: 'virtual-replace',
	REPLACE_IN_PERSON: 'in-person-replace',
} as const;
type Routers = (typeof Routes)[keyof typeof Routes];

async function sendEmail(route: Routers, props: UserData) {
	if (route && !Object.values(Routes).includes(route)) {
		throw logError(new Error(`Please use a valid email route.`));
	}

	const env = process.env.NEXT_PUBLIC_ENVIRONMENT === 'prd' ? 'prd' : 'stg';

	const url = `https://${env}.mtechapis.com/hvac/forms/${route}`;

	await fetch(url, {
		method: 'POST',
		body: JSON.stringify(props),
	}).catch((error) => {
		if (error instanceof Error) {
			logError(error);
		}
	});
}

export default sendEmail;
